export interface props {
  tag: string;
  children: React.ReactNode;
}

export const Tagged: React.FC<props> = (props) => {
  return <div className={props.tag}>{props.children}</div>;
};
